export const getApplicationSettings = (state, feature) =>
  state.application[feature]

export const getSourceSchemaSettings = state =>
  getApplicationSettings(state, 'sourceSchema')

export const getPartnersSettings = state =>
  getApplicationSettings(state, 'partners')

export const getSourceDebuggerSettings = state =>
  getApplicationSettings(state, 'sourceDebugger')

export const getWorkspaceSettingsSettings = state =>
  getApplicationSettings(state, 'workspaceSettings')
